import { RcCustomRequestOptions } from "antd/lib/upload/interface";
import COS from "cos-js-sdk-v5";
import BMF from 'browser-md5-file';
import { contentService } from "@/views/content/contentService";
import axios from "axios";
import { loadFileUrl, uploadFileUrl } from "./constants";

export interface ICOSUploadFileProps {
  options: RcCustomRequestOptions,
  onSuccess: (url: string, md5: string) => void,
  prefix?: string,
  onError?: (error: COS.CosError) => void,
  onMD5Progress?: (info: number) => void,
  onProgress?: (info: COS.ProgressInfo) => void,
}

export function COSUploadFile({ options, onSuccess, prefix = '', onError, onMD5Progress, onProgress }: ICOSUploadFileProps) {

  console.log(options);
  const formData = new FormData()
  formData.append('file', options.file)
  axios.post(uploadFileUrl, formData, {
      headers: { "Content-Type": "multipart/form-data;" },
  }).then(result => {
      onSuccess(loadFileUrl(result.data.retData), result.data.retData)
  }).catch(error => {
      onError?.(error)
  })
  return
  const bmf = new BMF();
  const file = options.file
  const cos = new COS({
    getAuthorization: (options, callback) => {
      console.log(options);
      contentService.getUpFileToken().then(ret => {
        const { retData } = ret
        const { credentials } = retData
        callback({
          TmpSecretId: credentials.tmpSecretId,
          TmpSecretKey: credentials.tmpSecretKey,
          SecurityToken: credentials.sessionToken,
          // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
          StartTime: retData.startTime, // 时间戳，单位秒，如：1580000000
          ExpiredTime: retData.expiredTime, // 时间戳，单位秒，如：1580000900
          ScopeLimit: true, // 细粒度控制权限需要设为 true，会限制密钥只在相同请求时重复使用
        });
      })
    }
  })



  bmf.md5(options.file, (err: any, md5: string) => {
    console.log('err:', err);
    console.log('md5 string:', md5); // 97027eb624f85892c69c4bcec8ab0f11
    // const fileName = `MD5-${md5}-${file.name}`
    // // 调用sdk上传接口获得相应的observable，控制上传和暂停
    // const observable = qiniu.upload(file, fileName, upFileToken.uptoken, putExtra, {
    //     // const observable = qiniu.upload({ ...file, name: fileName }, fileName, upFileToken.uptoken, putExtra, {
    //     useCdnDomain: true,
    //     disableStatisticsReport: false,
    //     retryCount: 6,
    //     region: qiniu.region.z1,
    //     debugLogLevel: 'INFO'
    // })
    // observable.subscribe({ next, error, complete })
    cos.uploadFile({
      Bucket: 'yhgw-1301309125',
      Region: "ap-beijing",
      // Bucket: 'wuchao-1300269367',
      // Region: "ap-beijing",
      // Query: "wms",
      Key: `${prefix ? prefix + '/' : ''}${md5}`,
      Body: file,
      onProgress: (info) => {
        console.log('upload info: ', info);
        // loaded: 20971520
        // percent: 0.09
        // speed: 3830414.61
        // total: 221172398
        // setPercent({ ...percent, uploadPercent: parseInt(Number(info.percent) * 100 + '') })
        onProgress?.(info)
      }
    }, (error, data) => {
      console.log('upload callback:', error, data);
      // Bucket: "yhgw-1301309125"
      // ETag: "\"a86e0cd3c6554e5ee7d9e9015d246007-211\""
      // Key: "a4f13fefc96c1f427f90e68bfea84a5b"
      // Location: "yhgw-1301309125.cos.ap-beijing.myqcloud.com/a4f13fefc96c1f427f90e68bfea84a5b"
      // RequestId: "NjE2ODE2NGRfMzJiMDJhMDlfNWQ1N180OGI0OGZk"
      // UploadId: "16342113562e5d67ec42c91b278bcbd29938cdb8c67b12185243185a93dc106fad41e336b9"
      // headers: { content - type: "application/xml", x - cos - request - id: "NjE2ODE2NGRfMzJiMDJhMDlfNWQ1N180OGI0OGZk" }
      // statusCode: 200
      if (data) {
        // setVideoUrl('https://' + data.Location)
        console.log("upload success: ", data)
        onSuccess('https://' + data.Location, md5)
      } else {
        onError?.(error)
      }
    })
  },
    (progress: number) => {
      console.log('progress number:', Number(progress) * 100);
      // setPercent({ ...percent, parsePercent: parseInt(Number(progress) * 100 + '') })
      onMD5Progress?.(progress)
    })
  // const putExtra = {
  //   customVars: {}
  // };


}

export function getCOSFileUrl(md5: string) {
  return loadFileUrl(md5)
  // return `https://yhgw-1301309125.cos.ap-beijing.myqcloud.com/${md5}`
}
